import React,{useState} from 'react'

import ImageDrawModal from "../canvas/ImageDrawModal";
import ImageDrawCard from "../canvas/ImageDrawCard";
import thumb20 from '../images/thumb_20.jpg';
import thumb21 from '../images/thumb_21.jpg';
import thumb22 from '../images/thumb_22.jpg';
import thumb23 from '../images/thumb_23.jpg';

import img20 from '../images/20.png';
import img21 from '../images/21.png';
import img22 from '../images/22.png';
import img23 from '../images/23.png';

import "./modal.css";


export default function Glaucoma(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img20);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    const cards = [
        { thumb: thumb20, image: img20, label: 'Glaucoma Progression', title: 'Glaucoma - Progression' },
        { thumb: thumb21, image: img21, label: 'Open Angle', title: 'Glaucoma - Open Angle' },
        { thumb: thumb22, image: img22, label: 'Closed Angle', title: 'Glaucoma - Closed Angle' },
        { thumb: thumb23, image: img23, label: 'Narrow Angle', title: 'Glaucoma - Narrow Angle' },
    ];
    return(
        <>
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body py-4">
                    {/* Heading */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="h5 fw-bold mb-0">Glaucoma</h3>
                    </div>

                    {/* Gallery */}
                    <div className="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
                        {cards.map((c, i) => (
                            <ImageDrawCard
                                key={i}
                                title={c.title}
                                thumb={c.thumb}
                                image={c.image}
                                onClick={handleShow}
                            />
                        ))}

                    </div>
                </div>
            </div>
            {/* Reusable modal */}
            {showImage && (
                <ImageDrawModal
                    show={show}
                    title={title}
                    image={showImage}
                    onClose={() => setShow(false)}
                />
            )}
        </>
    )
}